import { useState } from "react";
import {
  Typography,
  CircularProgress,
  Dialog,
  DialogContent,
  LinearProgress,
} from "@mui/material";

const Progress = ({ open, uploadProgress }) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogContent sx={{ textAlign: "center", py: 4 }}>
        <CircularProgress size={60} color="error" sx={{ mb: 3 }} />
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Uploading File...
        </Typography>
        {uploadProgress.total > 0 && (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              File Processing...
              {/* File Processing chunk {uploadProgress.current} of{" "}
              {uploadProgress.total} */}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={(uploadProgress.current / uploadProgress.total) * 100}
              sx={{ mb: 1, height: 8, borderRadius: 4 }}
              color="error"
            />
            <Typography variant="caption" color="text.secondary">
              {Math.round(
                (uploadProgress.current / uploadProgress.total) * 100
              )}
              %
            </Typography>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default Progress;
